<template>
    <div id="play-for-free" class="homepage__play-for-free">
        <div class="play-for-free">
            <h2 class="play-for-free__title">Play for free!</h2>
            <h2 class="play-for-free__title-2">Sign up as:</h2>
            <SignUpButtons />
        </div>
    </div>
</template>

<script>
import SignUpButtons from '@/landing/flows/LandingPage/components/SignUpButtons.vue';
import { mapGetters } from 'vuex';

export default {
    components: { SignUpButtons },
    computed: {
        ...mapGetters({ currentLanguage: 'getCurrentLanguage' }),
    },
};
</script>

<style lang="scss">
@use 'sass:color';
.homepage__play-for-free {
    background-color: #fff;
    background-image:
        url('/images/lp/stars-left-2.svg'), url('/images/lp/stars-right-2.svg');
    background-repeat: no-repeat, no-repeat;
    background-position:
        2% 5%,
        98% 5%;
    color: #333333;
    position: relative;
    z-index: 1;

    .play-for-free {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 7rem 1rem 4rem;
        margin-bottom: -2rem;

        @include mq($w-min-tablet, min) {
            margin-bottom: 0;
            padding-top: 4rem;
            padding-bottom: 6rem;
        }

        &__title {
            font-weight: 700;
            font-size: 24px;
            line-height: 20px;
            color: #333333;
            text-align: center;
            padding: 0.5rem;

            @include mq($w-min-tablet, min) {
                font-size: 36px;
                line-height: 44px;
                padding: 2rem;
            }
        }

        &__title-2 {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            color: #333333;
            margin-bottom: 1rem;

            @include mq($w-min-tablet, min) {
                font-size: 22px;
                line-height: 20px;
            }
        }

        .c-sign-up-buttons {
            margin: 0 -10px;
            width: auto;

            @include mq($w-max-tablet, max) {
                flex-direction: row;
                justify-content: center;
            }

            @include mq($w-max-phone, max) {
                flex-direction: column;
                align-items: center;
                margin-left: 0;
                margin-right: 0;
                width: 100%;
            }

            a {
                @include mq($w-max-phone, max) {
                    display: block;
                    width: 100%;
                    max-width: 200px;
                }
            }

            .math-button {
                margin: 8px;
                padding: 0 1rem;
                min-width: 160px;
                font-size: 26px;
                font-weight: 500;
                border-radius: 8px;

                @include mq($w-max-tablet, max) {
                    width: auto;
                }

                @include mq($w-max-phone, max) {
                    width: 100%;
                    margin-left: 0;
                    margin-right: 0;
                }

                img {
                    display: none;
                }
            }

            .math-button--teacher {
                min-width: 187px;
                font-style: normal;
                font-weight: bold;
                font-size: 23px;
                line-height: 20px;
                color: #fff;
            }

            .math-button--student,
            .math-button--parent {
                min-width: 131px;
                border: 2px solid #828282;
                background: none;
                font-style: normal;
                font-weight: bold;
                font-size: 18px;
                line-height: 20px;
                color: #828282;

                &:hover,
                &:focus {
                    color: #828282;
                    background-color: color.scale(#fff, $lightness: -10%);
                }
            }
        }
    }
}
</style>
